<template>
    <div class="story-maker-sticker story-maker-sticker-hashtag" :class="{edit : isEditing}" @click="()=>{if(isEditing) focusAtEnd($refs[`hashtagInput`])}">
        <img class="img-change-color" :src="require('../../../../../assets/img/instagram/ehf.png')">
        <p class="text-finish" @click="()=>finish()">Terminé</p>
        <div class="sticker sticker-hashtag" :class="`style${styleVariant}`"
            :style="{ 
                top: `${$attrs.position.y}%`, 
                left: `${$attrs.position.x}%`,
                transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : ''
            }"
        >
        <div class="icon"></div>
        <p
        :contenteditable="isEditing"
        @input="handlerInput"
        ref="hashtagInput"
        v-html="models.hashtag"
        class="textarea"
        ></p>
    </div>

    <div class="hashtags hide-scrollbar">
        <div class="hashtag" v-for="h in hashtags" @click="()=>selectHashtag(h.hashtag)">
            <!-- <img :src="m.image ? m.image : 'img/avatar.jpg'" alt=""> -->
            <p>#{{h.hashtag}}</p>
        </div>
    </div>
</div>
</template>

<script>
import store from './../../../../../store/index.js'
import minxinBots from './../../../../mixins/Bots.vue'
export default {
    mixins: [minxinBots],
    
    props: {
        id: [Number, String],
        isEditing: Boolean,
        hashtag: String,
        styleVariant: Number,
        isPreventCover: Boolean,
        isCover: Boolean,
        setCover: Function,
        setCbClick: Function,
    },
    
    data() {
        return {
            models: {
                hashtag: ''
            },
            cursorPosition: null,
            timeoutInitSearch: null,
            stateLoader: true,
            
            hashtags:[]
        };
    },
    
    mounted () {
        if (this.hashtag) this.$set(this.models,'hashtag', this.hashtag);
        
        if(this.isEditing) {
            this.$refs[`hashtagInput`].focus();
        }

        if (this.setCbClick) this.setCbClick(this.changeStyleVariant);
    },
    methods: {
        clickSticker() {
            if (this.isEditing) return 
            this.setCover(true)
            this.$nextTick(()=> {
                this.$emit('updateSticker',this.id , {
                    isEditing: true
                })   
                this.focusAtEnd(this.$refs[`hashtagInput`]);
            })
        },

        handlerInput(e) {
            this.updateCursorPosition()
            this.models.hashtag = e.target.innerHTML
            const newTextMention = e.target.innerHTML.replaceAll(' ',''); 
            this.$nextTick(() => {
                if (e.target.innerHTML !== newTextMention) {
                    this.models.hashtag = newTextMention
                    this.cursorPosition = this.cursorPosition > 0 ? this.cursorPosition - 1 : 0
                    this.$nextTick(() => {
                        this.restoreCursorPosition()
                        this.searchHashtags()
                    })
                }else{
                    this.restoreCursorPosition()
                    this.searchHashtags()
                }
            })
            
            
        },

        focusAtEnd(element) {
            if (!element || !element.isContentEditable) return;

            const range = document.createRange();
            const selection = window.getSelection();

            range.selectNodeContents(element);
            range.collapse(false);

            selection.removeAllRanges();
            selection.addRange(range);

            // Donnez le focus à l'élément
            element.focus();
        },
        
        updateCursorPosition() {
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                let nodeIndex = 0
                if (this.cursorPosition !== range.startOffset) {
                    this.cursorPosition = range.startOffset
                }
            }
        },
        
        restoreCursorPosition() {
            this.$refs[`hashtagInput`].focus();
            let node = this.$refs[`hashtagInput`].childNodes[0]
            const selection = window.getSelection();
            selection.removeAllRanges();
            const range = document.createRange();
            range.setStart(node, this.cursorPosition);
            range.collapse(true);
            selection.addRange(range);
        },

        selectHashtag(value) {
            this.models.hashtag = value
            this.finish()
        },
        
        finish() {
            if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
            
            if (!this.models.hashtag) {
                this.$emit('deleteSticker',this.id)
                return
            }
          
            this.$emit('updateSticker',this.id , {
                isEditing: false,
                data : {
                    ...this.$attrs.data,
                    hashtag: this.models.hashtag,
                },
            })
            this.hashtags = []
            
            if (this.timeoutFinish) clearTimeout(this.timeoutFinish)
            this.timeoutFinish = setTimeout(() => {
                this.setCover(false)
            }, 200);
        },

        async searchHashtags() {
            if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
            this.stateLoader = true
            this.timeoutInitSearch = setTimeout(async () => {
                let page = null   
                page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created) || this.allPages.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
             
                if (page && this.$refs[`hashtagInput`].innerText) {
                    this.stateLoader = true
                    this.hashtags = (await this.getHashtagsByApi(page.id, this.$refs[`hashtagInput`].innerText)).body.hashtags
                    this.stateLoader = false
                }
            },1000)
        },

        changeStyleVariant(e) {
            this.$emit('updateSticker',this.id , {
                data : {
                    ...this.$attrs.data,
                    styleVariant :(this.styleVariant % 6) + 1
                },
            })
        }
    },
    
    watch: {
        hashtag(newValue, oldValue) {
            if (newValue) this.$set(this.models,'hashtag', newValue);
        },

        isEditing: {
            handler(newValue) {
                if (newValue && !this.isPreventCover && !this.isCover) {
                    this.isEditing = false
                    this.clickSticker()
                }
            },
            immediate: true
        },
    },
    
    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'];
        },
    },
};
</script>
